import { useState } from 'react';
import { useDispatch } from "react-redux";
import { IonButton, IonItem } from '@ionic/react';

import { applyCouponToLoad, removeCouponFromLoad } from '@/actions/loads';
import { inDollars } from '@/helpers/humanize';
import ValidatedInput from '@/components/ValidatedInput';

export default function CouponEntry({load}) {
  const dispatch = useDispatch();
  const appliedAmount = load.coupon?.discount_cents;
  const [error, setError] = useState();
  const [code, _setCode] = useState(load.coupon?.code ?? "");

  const setCode = (value) => {
    _setCode(value);
    setError(null);
  };

  const applyCoupon = async () => {
    try {
      const response = await dispatch(applyCouponToLoad(load, code));
      setCode(response.load.coupon?.code);
    } catch (e) {
      setError(_.get(e, 'response.data.error', e.message));
    }
  };

  const removeCoupon = async () => {
    setCode("");
    try {
      await dispatch(removeCouponFromLoad(load));
    } catch (e) {
      setError(_.get(e, 'response.data.error', e.message));
    }
  };

  return (
    <IonItem lines="none">
      <ValidatedInput label="Coupon Code"
        value={code}
        setValue={setCode}
        style={appliedAmount && {"--color": "var(--ion-color-success)"}}
        readonly={appliedAmount}
        valid={!code || !error}
        helperText={appliedAmount ? `Discount applied: ${inDollars(appliedAmount)}` : ' '}
        errorText={error} />
      {appliedAmount ? (
        <IonButton type="button" color="warning" onClick={removeCoupon} disabled={!code}>
          Remove
        </IonButton>
      ) : (
        <IonButton type="button" color="tertiary" onClick={applyCoupon} disabled={!code}>
          Apply
        </IonButton>
      )}
    </IonItem>
  );
}
